import { load as loadSubscriptions } from '@ms/yammer-data/dist/domains/pushSubscriptions/actions';
import { getSubscription } from '@ms/yammer-web-support/dist/pushNotifications';
import type { MutableRefObject } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useIsEnabled as useIsPushNotificationsEnabled } from '../pushNotifications';

export const useLoadPushSubscriptions = (subscription: MutableRefObject<PushSubscription | null | undefined>): void => {
  const dispatch = useDispatch();
  const isEnabled = useIsPushNotificationsEnabled();

  useEffect(() => {
    (async () => {
      // eslint-disable-next-line react-hooks/immutability
      subscription.current = await getSubscription();

      if (isEnabled) {
        await dispatch(loadSubscriptions());
      }
    })();
  }, [subscription, dispatch, isEnabled]);
};
